import React from 'react';
import './Collections.css';

const Collections = () => {
  const collections = [
    {
      id: 1,
      title: "Hoodies & Sweatshirts",
      description: "Premium streetwear essentials designed for comfort and style. Perfect for those who move in the shadows.",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20.38 3.46L16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/>
        </svg>
      ),
      className: "saparte"
    },
    {
      id: 2,
      title: "Masks & Accessories",
      description: "Complete your anonymous look with our signature masks and street accessories that define the NoFace identity.",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
          <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
        </svg>
      ),
      className: "pusticant"
    },
    {
      id: 3,
      title: "Streetwear Tops",
      description: "Bold graphic tees and statement pieces that speak to the energy of urban culture and street rebellion.",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
          <line x1="8" y1="21" x2="16" y2="21"/>
          <line x1="12" y1="17" x2="12" y2="21"/>
        </svg>
      ),
      className: "hows"
    },
    {
      id: 4,
      title: "Limited Drops",
      description: "Exclusive releases that drop without warning. Be part of the underground movement that defines street culture.",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
          <polyline points="3.27,6.96 12,12.01 20.73,6.96"/>
          <line x1="12" y1="22.08" x2="12" y2="12"/>
        </svg>
      ),
      className: "connation"
    }
  ];

  return (
    <section id="collections" className="collections-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Collections</h2>
        </div>
        <div className="collections-grid">
          {collections.map((collection) => (
            <div key={collection.id} className="collection-card">
              <div className={`collection-icon ${collection.className}`}>
                {collection.icon}
              </div>
              <h3 className="collection-title">{collection.title}</h3>
              <p className="collection-description">{collection.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Collections;
